<template>
  <div :class="{ 'gesture-button': true, 'encrypted': isEncrypted }" v-loading="loading">
    <span v-if="isEncrypted">{{ encryptedText }}
      <img @click="toggleEncryption" src="https://cdn-image.yucrm.cn/images/jd-front-platform/images/隐藏.svg" alt="" v-if="isNeed">
    </span>
    <span v-else>{{ decryptedText }}
      <img @click="toggleEncryptionClose" src="https://cdn-image.yucrm.cn/images/jd-front-platform/images/展开.svg" alt="">
    </span>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { decrypt  } from "@/api/public";
export default {
  props: {
    text: {
      type: String,
      required: true
    },
    isNeed:{
      type: Boolean,
      default: true,
    },
    decryptText:{
      type: String,
      default: '',
    },
    needMockCheck:{
      type: Boolean,
      default: false,
    }
  },
  data() {
    return {
      isEncrypted: true,
      decryptedText:'',
      loading: false,
    };
  },
  computed: {
    ...mapGetters(["loginUserInfo"]),
    encryptedText() {
      if(this.text){
        let end = ""

        if(this.text.length > 6 ){
          end = this.text.slice(7)
          return this.text.substring(0,3) + '****' + end;
        }else{
          if(this.text.length > 2) end = this.text.charAt(this.text.length - 1)
          return this.text.charAt(0) + '**' + end;
        }

      }else{
        return ""
      }
      
    },
    // decryptedText() {
    //   return this.text;
    // }
    decryptText2(){
      return this.decryptText;
    }
  },
  methods: {
    toggleEncryptionClose() {
      this.isEncrypted = !this.isEncrypted;
    },
    toggleEncryption() {
      if (this.needMockCheck && this.loginUserInfo.isSimulation) {
        this.$message.error('非法登录不支持操作');
        return;
      }
      // 传入了待解密的密文，需调解密接口
      if (this.decryptText2) {
        this.loading = true;
        decrypt({ content: this.decryptText2 }).then((res) => {
          // 说明：HTTP 拦截器对业务错误码已统一弹 Message.error，此处不再重复提示
          if (res && res.code == 1) {
            this.decryptedText = res.data;
            // 解密成功后才切换为明文展示
            this.isEncrypted = false;
          } else if (res && res.code === 0 && res.message) {
            // code=0 时拦截器只放行不提示，需自行抛出错误信息
            this.$message.error(res.message);
          }
          // 其余错误码拦截器已弹错，保持脱敏态即可，用户可重新点击重试
        }).catch(() => {
          // 兜底捕获异常（如 res 为空后的处理），避免 loading 一直转动
          this.$message.error('解密失败，请稍后重试');
        }).then(() => {
          // 等价 finally：无论成功失败都关闭 loading，兼容不支持 Promise.finally 的环境
          this.loading = false;
        });
      } else {
        // 无密文（如员工姓名）直接展示原文
        this.decryptedText = this.text;
        this.isEncrypted = false;
      }
    }
  }
};
</script>

<style scoped>
.gesture-button {
  display: inline-block;
  cursor: pointer;
  user-select: none;
  transition: all 0.3s ease;
}

.gesture-button:hover {
  /* background-color: #f0f0f0; */
}

.encrypted {
  /* font-style: italic; */
  /* color: #999; */
}
</style>
